/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import CRMLeadOpportunityBody from "components/CRMComponents/CRMLeadInformationComponents/CRMLeadOpportunity/CRMLeadOpportunityBody/CRMLeadOpportunityBody";

const CrmLeadOpportunities = () => {
  useEffect(() => {
    document.title = "CRM Lead Information | Opportunity";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <CRMLeadOpportunityBody />
    </main>
  );
};

export default CrmLeadOpportunities;
